import { render, staticRenderFns } from "./StatisticsMailQueueDetails.vue?vue&type=template&id=24d7f2fe&scoped=true"
import script from "./StatisticsMailQueueDetails.vue?vue&type=script&lang=js"
export * from "./StatisticsMailQueueDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d7f2fe",
  null
  
)

export default component.exports